import { render, staticRenderFns } from "./AscNotificationsButton.vue?vue&type=template&id=73731c1f&"
import script from "./AscNotificationsButton.vue?vue&type=script&lang=js&"
export * from "./AscNotificationsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports